import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import {
    TrademeCoreUiModule
} from '@classifieds-sell/trademe-core-ui';
import {
    TgButtons2Module,
    TgGridModule,
    TgIconBasicCrossFramedModule,
    TgIconBasicWarningModule,
    TgInfoBoxModule,
    TgInputModule,
    TgLists2Module,
    TgSelectModule
} from '@trademe/tangram';
import { ListingDurationService } from '../../../services/listing-duration.service';
import { PropertyOpenHomeTimesSectionComponent } from './property-open-home-times-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgButtons2Module,
        TrademeCoreUiModule,
        TgInfoBoxModule,
        TgLists2Module,
        TgIconBasicWarningModule,
        TgIconBasicCrossFramedModule,
        TrademeCoreUiPipeModule
    ],
    declarations: [PropertyOpenHomeTimesSectionComponent],
    providers: [ListingDurationService],
    exports: [PropertyOpenHomeTimesSectionComponent]
})
export class PropertyOpenHomeTimesSectionModule {}
